import { render, staticRenderFns } from "./MainHeaderSearch.vue?vue&type=template&id=0135c41e&"
import script from "./MainHeaderSearch.vue?vue&type=script&lang=js&"
export * from "./MainHeaderSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0135c41e')) {
      api.createRecord('0135c41e', component.options)
    } else {
      api.reload('0135c41e', component.options)
    }
    module.hot.accept("./MainHeaderSearch.vue?vue&type=template&id=0135c41e&", function () {
      api.rerender('0135c41e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainHeaderSearch.vue"
export default component.exports